import { useEffect, useState } from "react";
import { COUNTRIES } from "static/countries";

const flagCache: { [key: string]: string } = {};

const fetchFlag = async (code: string, url: string): Promise<string> => {
  if (flagCache[code]) return flagCache[code];
  
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    flagCache[code] = url;
    return url;
  } catch (error) {
    console.log(`Failed to load flag for ${code}:`, error);
    // Return a fallback flag or the original URL
    return url;
  }
};

export const useCountries = (specificCodes?: string[]) => {
  const [countries, setCountries] = useState<any[]>([]);

  useEffect(() => {
    let result = COUNTRIES;
    if (specificCodes?.length) {
      result = result.filter(
        (c) =>
          specificCodes.includes(c.alpha2Code) ||
          specificCodes.includes(c.alpha3Code)
      );
    }
    setCountries(result);
  }, [specificCodes]);

  return { countries, fetchFlag };
};
